import Config from '../launch/config'
import Ship from '../ship/ship'

export default class Satellite extends Ship {
    constructor(props = {}) {
        const chance = Config.chance

        props.type = 'satellite'
        props.scale = 0.1
        props.diameter = 4

        props.name = chance.capitalize(
            chance.pick([chance.word({syllables: 1})])
        )

        props.matterConfig = {
            density: 0.05, // default 0.001
            friction: 0.1,
            restitution: 0.8, // default 0
        }

        props.selectedTexture = 'satelliteWhite'

        super(props)

        // Texture - Rank-based
        // TODO: sort this out using config instead
        const enemyTextureMap = {
            0: 'satelliteRed',
            1: 'satelliteOrange',
            2: 'satelliteBlue',
            3: 'satelliteGreen',
        }
        const isEnemy = this.faction?.includes(Config.enemyFactionName)
        let defaultTexture = 'satelliteGreen'

        if (isEnemy) {
            defaultTexture =
                enemyTextureMap[this.faction.at(-1)] || 'satelliteRed'
        }

        // Rank-based
        if (this.rank > 0 && !isEnemy) {
            defaultTexture =
                this.faction === Config.userFactionName
                    ? `satelliteGreenRank${this.rank}`
                    : 'satelliteRed'
        }

        this.texture = defaultTexture

        props.proximityRange =
            props.diameter +
            Config.shipRanks[`rank${this.rank}`].satelliteProximityRange

        props.sensorRange =
            props.diameter +
            Config.shipRanks[`rank${this.rank}`].satelliteSensorRange
    }
}
